/**
 * The name of the demo notebook auto created for a user
 */
export const DEMO_NOTEBOOK_NAME = 'Welcome to Actually Colab';
